import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.toggle = document.querySelector('.c-menu-toggle')
    this.menu = document.querySelector('.c-menu')
    this.menuMask = document.querySelector('.c-menu_mask')

    this.onClickToggle = this.onClickToggle.bind(this)
    this.onClickMenuMask = this.onClickMenuMask.bind(this)

    this.toggle.addEventListener('click', this.onClickToggle)
    this.menuMask.addEventListener('click', this.onClickMenuMask)
  }

  onClickToggle() {
    this.toggle.classList.toggle('-active')
    this.menu.classList.toggle('-visible')
    this.menuMask.classList.toggle('-visible')

    if (this.menu.classList.contains('-visible')) {
      this.call('stop', 'Scroll')
    }
    else {
      this.call('start', 'Scroll')
    }
  }

  onClickMenuMask() {
    this.toggle.classList.remove('-active')
    this.menu.classList.remove('-visible')
    this.menuMask.classList.remove('-visible')
    this.call('start', 'Scroll')
  }

  destroy() {
    this.toggle.removeEventListener('click', this.onClickToggle)
    this.menuMask.removeEventListener('click', this.onClickMenuMask)
  }
}
